import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ** 共用區
import { NavHeaderModule } from './nav-header/nav-header.module';
import { FooterModule } from './footer/footer.module';
import { PartnershipModule } from './partnership/partnership.module';
import { PagechangeBtnModule } from './feature/pagechange-btn/pagechange-btn.module';
import { ContactDialogModule } from './contact-dialog/contact-dialog.module';
import { CookiesDialogModule } from './cookies-dialog/cookies-dialog.module';
import { StatisticsModule } from './statistics/statistics.module';

// ** primeNg
import { ChipsModule } from 'primeng/chips';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { DividerModule } from 'primeng/divider';
import { TabViewModule } from 'primeng/tabview';
import { ProgressBarModule } from 'primeng/progressbar';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		FooterModule,
		PartnershipModule,
		NavHeaderModule,
		PagechangeBtnModule,
		ContactDialogModule,
		CookiesDialogModule,
		StatisticsModule,

		ButtonModule,
		ChipsModule,
		AccordionModule,
		DividerModule,
		TabViewModule,
		ProgressBarModule,
	],
	exports: [
		CommonModule,
		FooterModule,
		PartnershipModule,
		NavHeaderModule,
		PagechangeBtnModule,
		ContactDialogModule,
		CookiesDialogModule,
		StatisticsModule,

		ButtonModule,
		ChipsModule,
		AccordionModule,
		DividerModule,
		TabViewModule,
		ProgressBarModule,
	],
})
export class SharedModule {}
